/**
 * Grooming types (epic PI-SPEC-SW-E279). Re-exported by `@spectree/shared`.
 *
 * Each string union is derived from an `as const` array so API Zod schemas
 * (`z.enum(GROOMING_BATCH_STATUSES)`) and UI pickers reuse the same list.
 * Browser-safe: no runtime dependencies.
 */
/** Where an item stands on the way to a grooming session. */
export const GROOMING_STAGES = ["needs-information", "ready-to-groom", "groomed"];
/**
 * How a batch's items were chosen: the session `agenda`, every `unestimated`
 * item, every item carrying the groom tag (`tagged`), or one `single` item.
 */
export const GROOMING_BATCH_MODES = ["agenda", "unestimated", "tagged", "single"];
/** Lifecycle of a batch. `draft` is the editable session agenda. */
export const GROOMING_BATCH_STATUSES = ["draft", "running", "stopped", "completed", "canceled"];
/**
 * Lifecycle of one item in a batch. `current` marks the item a live session
 * is discussing; `not-ready` means it failed the grooming bar when the run
 * reached it.
 */
export const GROOMING_BATCH_ITEM_STATUSES = [
    "queued",
    "running",
    "briefed",
    "not-ready",
    "failed",
    "skipped",
    "current",
];
/** Review of a held brief before it is posted to the tracker. */
export const GROOMING_REVIEW_STATES = ["pending", "posted", "skipped"];
/** Why a batch stopped before finishing every item. */
export const GROOMING_STOP_REASONS = ["usage-limit", "user", "environment", "error"];
/**
 * Phases of one item's run, in order, as the engine reports them in
 * `item-progress` events (contract 2): updating the repository copies,
 * reading the code, writing the brief.
 */
export const GROOMING_RUN_PHASES = ["updating-repos", "reading-code", "writing-brief"];
/** How much of a product area a change touches. */
export const PRODUCT_AREA_LEVELS = ["main", "small", "check"];
/** Who last wrote a product area: the AI draft or a person. */
export const PRODUCT_AREA_SOURCES = ["ai", "person"];
/**
 * Where a mapped repository's code is hosted (epic PI-SPEC-SW-E318, ER-1683):
 * Azure DevOps Repos or github.com. A stored entry without a host is ADO.
 */
export const GROOMING_REPO_HOSTS = ["ado", "github"];
//# sourceMappingURL=types.js.map